<div class="container-fluid pt-3 pb-4 py-sm-5 px-sm-5">
  <div *ngIf="formContent$ | async as content">
    <div class="py-3 py-sm-4 text-center">
      <h1 class="d-inline-block align-middle m-0" data-test-id="manage-project-title">
        {{ 'CREATE_PROJECT_TITLE_HINT' | translate }}
      </h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-8">
        <app-form-constructor [formContent]="content"></app-form-constructor>
        <small class="form-text text-muted required-hint" data-test-id="small-required">
          * - {{ 'REQUIRED_FIELD_HINT' | translate }}
        </small>
        <div class="mt-2">
          <button
            appLongOperation
            class="btn btn-primary"
            type="submit"
            data-test-id="btn-manage-project"
            (click)="submitForm($event)"
          >
            {{ 'BTN_SUBMIT_HINT' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-secondary pt-300 ms-3"
            data-test-id="btn-cancel-manage-project"
            (click)="onCancel()"
          >
            {{ 'BTN_CANCEL_HINT' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
